export default __webpack_public_path__ + "static/media/fileDown.79ae0357.svg";